import {register} from '@shopify/theme-sections';

import ResultsFilterSort from '../components/results-filter-sort';
import initCollectionDescriptionToggle from '../components/collection-description';

const sectionType = 'main-collection';
const registeredSections = window.Shopify?.theme?.sections?.registered || {};
const isUnregistered = typeof registeredSections[sectionType] === 'undefined';

export default isUnregistered &&
  register(sectionType, {
    onLoad() {
      ResultsFilterSort(this.container, this.id);

      initCollectionDescriptionToggle(this.container);
    },
  });
